
import { Component, QueryList, ViewChildren } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { TopicContent } from 'app/shared/models/topic-content.model';
import { SortEvent } from 'app/tables/angular/sortable.directive';

 export const TOPICCONTENTS: TopicContent[] = [
  {
    id: '1',
    title: 'test1',
    type: 'text',
    content: 'TESTWE'
  },
  {
    id: '1',
    title: 'test1',
    type: 'text',
    content: 'TESTWE'
  },
  {
    id: '1',
    title: 'test1',
    type: 'text',
    content: 'TESTWE'
  },
  {
    id: '1',
    title: 'test1',
    type: 'text',
    content: 'TESTWE'
  },
  {
    id: '1',
    title: 'test1',
    type: 'text',
    content: 'TESTWE'
  },


];



@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent {

  topicContents$: Observable<TopicContent[]>;
  total$: Observable<number>;
  constructor() {
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers

  }

}
